import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import ItemRevisionModel from '../../../models/ItemRevisionModel';
import DataService from "../../../services/data.service";
import FormatUtils from '../../../utils/FormatUtils';
import ChangeItemImagePopup from "../Popups/ItemRevision_popup_ChangeItemImage"

interface IProps {
    itemRevision: ItemRevisionModel,
    refreshNr: number
}

const ItemRevision_tab_SubItemRevisions: React.FC<IProps> = ({ itemRevision, refreshNr }) => {
    const [data, setData] = useState<ItemRevisionModel[]>();
    const [selectedRow, setSelectedRow] = useState<ItemRevisionModel>();
    const [itemStatusTypes, setItemStatusTypes] = useState<string[]>()
    const formatUtils = new FormatUtils()


    const { handleException } = useNotifications();
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        getTableData();
    }, [itemRevision.id, refreshNr]);

    function getTableData() {
        DataService.get<ItemRevisionModel[]>('api/v1/ItemRevisions/ByParentItemRevision/' + itemRevision.id)
            .then(response => {
                let statusTypes: string[] = []
                response.forEach(x => {
                    x.itemRevisionStatuses.forEach(y => {
                        var endDateStatusType = formatUtils.dateFromString(y.itemStatus.itemStatusType.endDate)
                        var endDateStatus = formatUtils.dateFromString(y.itemStatus.endDate)
                        if ((endDateStatusType === undefined || endDateStatusType > new Date(Date.now())) &&
                            (endDateStatus === undefined || endDateStatus > new Date(Date.now()))) {
                            if (y.isLatest && statusTypes.includes(y.itemStatus.itemStatusType.name) == false) {
                                statusTypes.push(y.itemStatus.itemStatusType.name);
                            }
                        }
                    })
                });

                setItemStatusTypes(statusTypes)

                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function getStatusColor(itemRevision: ItemRevisionModel, colInfo: IColInfo): string | undefined {
        if (itemRevision && itemRevision.itemStatus)
            return itemRevision.itemStatus.color;
    }

    function getStatus(itemRevision: ItemRevisionModel, colInfo: IColInfo): string | undefined {
        const status = colInfo.dataProp;
        let result = ''

        itemRevision.itemRevisionStatuses.forEach(y => {
            var endDateStatus = formatUtils.dateFromString(y.itemStatus.endDate)
            if (endDateStatus === undefined || endDateStatus > new Date(Date.now())) {
                if (y.isLatest == true && y.itemStatus.itemStatusType.name == status) {
                    result = y.itemStatus.name;
                }
            }
        })

        return result;
    }

    function showChangeItemImagePopup(rowData: ItemRevisionModel, colInfo: IColInfo) {
        setSelectedRow(rowData)
        setShowPopup(true)
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { dataProp: 'col-1', getCellBackgroundColor: getStatusColor, sort: false, width: 5 },
        { title: '', dataProp: 'thumbnailUrl', dataType: 'bigimage', onCellClick: showChangeItemImagePopup },
        { title: 'Item Nr', dataProp: 'item.itemNr', sort: 'asc' },
        { title: 'Color', dataProp: 'colors', dataType: 'workflowItemRevisions', sort: false },
        { title: 'Name', dataProp: 'item.name'},
        { title: 'Version', dataProp: 'revisionNumber' },
        { title: 'Active from', dataProp: 'beginDate', dataType: 'date' },
        { title: 'until', dataProp: 'endDate', dataType: 'date' },
        { title: 'Created on', dataProp: 'createdOn', dataType: 'datetime' },
        { title: 'Created by', dataProp: 'createdByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
    ];

    if (itemStatusTypes) {
        itemStatusTypes.forEach((value, index) => {
            colInfos.push({ title: value, dataProp: value, getCellData: getStatus, filterInfo: { filterType: 'CheckboxList', filterMenuWidth: 325 } });
        });
    }

    return (
        <>
            <DataTable
                name='dtItemSubItems'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Itemrevision'
                navigateUrl='/plm/Items/ItemRevision/'
            />
            {selectedRow && showPopup && <ChangeItemImagePopup show={showPopup} onHide={() => { setShowPopup(false); getTableData() }} itemRevisionId={selectedRow.id} />}
        </>
    );
}
export default ItemRevision_tab_SubItemRevisions;